// src/pages/SubscriptionPage.tsx
// PRC-023 / PRC-036: con suscripción vigente, «Mi suscripción» (boceto G4).
// PRC-043: sin suscripción de pago (prueba o acceso en pausa), la página de
// planes (boceto G8), que se define una sola vez en pricingPlans.ts.
import React from 'react';
import { useAuth } from '../context/AuthContext';
import MySubscriptionPanel from '../modules/pricingJourney/components/MySubscriptionPanel';
import PlansPage from '../modules/pricingJourney/pages/PlansPage';

const SubscriptionPage: React.FC = () => {
  const { pricingAccess } = useAuth();
  return pricingAccess?.state === 'paid' ? <MySubscriptionPanel /> : <PlansPage />;
};

export default SubscriptionPage;
